import { render, staticRenderFns } from "./groupLessonsList.vue?vue&type=template&id=ea243532&"
import script from "./groupLessonsList.vue?vue&type=script&lang=js&"
export * from "./groupLessonsList.vue?vue&type=script&lang=js&"
import style0 from "./groupLessonsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports